import { Layout } from 'antd';
import styled from 'styled-components';

export const DefaultLayoutWrapper = styled(Layout)`
  flex-direction: row;
`;
